import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareSearchIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 17 18' {...props}>
    <path
      fill='currentColor'
      d='M15.814 14.861l-3.124-3.124a.752.752 0 00-.533-.219h-.51a6.513 6.513 0 00-9.738-8.612 6.513 6.513 0 008.61 9.74v.511a.752.752 0 00.22.533l3.123 3.123a.75.75 0 001.062 0l.886-.886a.756.756 0 00.004-1.066zm-9.302-1.838a5.512 5.512 0 01-3.893-9.414 5.513 5.513 0 117.794 7.802 5.51 5.51 0 01-3.906 1.612h.005z'
    />
  </SvgWrapper>
);

export const SearchIcon = memo(BareSearchIcon);
